import api from '../api/axios';
import { getConsents } from '../api/services/consents';
import store from '@/stores/store';
import { logError } from './logHandling';

export async function startCheckConsent() {
  if (!store.getState().isTherapistDemo || !store.getState().isPatientDemo) {
    try {
      const consents = (await getConsents()).data.documents;
      if (consents.length <= 0) {
        return;
      }

      // we only take the first consent so that with each reload, only one consent modal is shown at a time
      updateStoreWithConsent(consents[0]);
    } catch (error) {
      logError('Error while loading consents', error);
    }
  }
}

function updateStoreWithConsent(consent: { buttonText: string }) {
  store.getActions().setShowConsentModal({
    document: consent,
    buttonText: consent.buttonText,
    show: true,
  });
}

export async function updateConsent(
  consentId: string,
  isConsentGiven: boolean,
) {
  return await api.post('/api/users/consents/revoke', {
    consentID: consentId,
    givenConsent: isConsentGiven,
  });
}
